import { SVG, SVGProps } from './svg'

export function IconToolMidlineV(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M15.5 14.06a.5.5 0 010-.06V5a.5.5 0 011 0v9a.5.5 0 010 .06 2 2 0 010 3.88.5.5 0 010 .06v9a.5.5 0 01-1 0v-9a.5.5 0 010-.06 2 2 0 010-3.88zM17 16a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </SVG>
  )
}
